(function () {
  'use strict';

  var ASSET_BASE = '';
  var TOTAL_QUESTIONS = 14;

  /** Mirrors Tailwind classNames from QuizPrimitives.tsx + Index.tsx */
  var T = {
    fade: 'animate-fade-up',

    headline: 'mb-2.5 text-center text-[26px] font-bold leading-[1.25] text-foreground',
    headlineSm: 'mb-4 text-center text-[22px] font-bold leading-[1.25] text-foreground',

    qtext: 'mb-1.5 text-center text-[19px] font-bold leading-[1.3] text-foreground',
    qtextMuted: 'mb-1.5 mt-6 text-center text-[19px] font-bold leading-[1.3] text-foreground',

    subline: 'mb-6 text-center text-sm leading-relaxed text-muted-foreground',

    optRow: 'mt-3 flex flex-col gap-2.5',
    /** Same as SimpleQ list in Index.tsx (`flex flex-col gap-2.5 mt-4`) */
    optRowSimpleQ: 'mt-4 flex flex-col gap-2.5',
    chkRow: 'mt-2 flex flex-col gap-2',

    optBtn:
      'quiz-opt flex w-full items-center gap-3 rounded-xl border-[1.5px] border-border bg-card px-4 py-3.5 text-left text-sm font-medium text-foreground transition-all hover:border-primary hover:bg-primary-tint',
    optBtnOn: 'border-primary bg-primary-soft text-primary-deep',
    optIcon: 'w-6 shrink-0 text-center text-lg',

    chkBtn:
      'quiz-chk flex w-full items-center gap-3 rounded-xl border-[1.5px] border-border bg-card px-4 py-3 text-left transition-all hover:border-primary hover:bg-primary-tint',
    chkBtnOn: 'border-primary bg-primary-soft',
    chkMarkerOn: 'border-primary bg-primary text-primary-foreground',
    chkLabel: 'text-[13px] font-medium',

    nextBtn:
      'quiz-next quiz-continue-btn mt-4 w-full rounded-xl bg-gradient-primary py-3.5 text-[15px] font-bold tracking-wide text-primary-foreground shadow-card transition-opacity hover:opacity-90',
    bigCta:
      'w-full rounded-xl bg-gradient-primary block py-4 text-base font-bold tracking-wide text-primary-foreground shadow-card transition hover:opacity-90',

    progWrap: 'mb-7',

    stainGrid: 'grid grid-cols-2 gap-2.5',
    stainBtn:
      'quiz-stain rounded-xl border-[1.5px] border-border bg-card p-3 text-center transition-all hover:border-primary hover:bg-primary-tint',
    stainBtnOn: 'border-primary bg-primary-soft',
    stainIcon: 'mb-1 block text-2xl',
    stainLbl: 'text-[12px] font-semibold text-foreground',
  };

  var TEETH_CHOICES = [
    ['white', ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/white_fba9a802-bf21-470f-8630-3bd835900dec.png?v=1779277054', 'White & healthy'],
    ['yellow', ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/yellow_9e419285-779d-45c5-9126-ce0d61bca2b2.png?v=1779277054', 'Slightly yellow'],
    ['worn', ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/worn_265f855d-b54c-4a6d-baf7-545841eff7d8.png?v=1779277055', 'Worn & chipped'],
    ['fragile', ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/fragile_e6b3bf2c-8590-4280-a552-c4994619abfa.png?v=1779277054', 'Thinning & fragile'],
  ];

  var concernChoices = [
    ['😬', 'Discomfort to hot & cold foods'],
    ['😐', 'Yellowing and staining'],
    ['🦷', 'Weak or thinning enamel'],
    ['💨', 'Bad breath'],
    ['😁', 'Overall confidence in my smile'],
  ];

  var stainChoices = [
    ['☕', 'Coffee or tea'],
    ['🍷', 'Wine or dark drinks'],
    ['🚬', 'Smoking / tobacco'],
    ['🎂', 'Age yellowing'],
    ['🍕', 'Food and snacks'],
    ['❓', 'Not sure'],
  ];

  var hopeChoices = [
    'Whiter, brighter teeth',
    'Stronger-feeling teeth',
    'Fresher breath all day',
    'More confidence in my smile',
    'All of the above',
  ];

  var routineChoices = [
    'Regular toothpaste',
    'Mouthwash',
    'Whitening strips',
    'LED whitening kit',
    'Floss or floss picks',
    'Sugar-free or xylitol gum',
    'None of these',
  ];

  var warningChoices = [
    'My teeth react to hot or cold drinks',
    'Gums that feel tender or irritated',
    'Visible white spots on teeth',
    "Bad breath that doesn't go away",
    'None of these',
  ];

  var state = { answers: {} };
  var analyzingTimeouts = [];
  var applyingTimeouts = [];

  /**
   * Progress bar markup: track + fill + tooth icon use inline dimensions / colors derived from CSS
   * variables so the bar stays visible even when the Play CDN has not JIT-compiled Tailwind utilities
   * that only appear inside this script (known CDN limitation).
   */
  function progressInnerHtml(step, total, labelOptional) {
    var pct = Math.round((step / total) * 100);
    var halfMessage =
      step === 9 || step === 10 ? "You're doing great! We're almost there." : null;
    var displayLabel = typeof labelOptional === 'undefined' ? halfMessage : labelOptional;

    var hint = '';
    if (displayLabel && String(displayLabel).replace(/\u200b/g, '').trim()) {
      hint =
        '<div class="mb-2 text-center text-[12px] font-semibold text-primary">' +
        escHtml(String(displayLabel)) +
        '</div>';
    }

    var tooth =
      step > 1
        ? '<img src="' +
          ASSET_BASE +
          'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/progress-tooth.png?v=1779276911" alt="" aria-hidden="true" style="position:absolute;top:50%;left:' +
          pct +
          '%;width:1.75rem;height:1.75rem;transform:translate(-50%,-50%);pointer-events:none;opacity:0.92;transition:left 0.5s ease;mix-blend-mode:multiply;"/>'
        : '';

    return (
      hint +
      '<div style="position:relative;height:3px;border-radius:9999px;background:hsl(var(--border))">' +
      '<div style="height:100%;width:' +
      pct +
      '%;border-radius:inherit;background:hsl(var(--primary));transition:width 0.5s ease"></div>' +
      tooth +
      '</div>'
    );
  }

  /** Play CDN sometimes misses injected utilities; safe no-op elsewhere. */
  function twRefreshSafe() {
    try {
      if (typeof tailwind !== 'undefined' && typeof tailwind.refresh === 'function') tailwind.refresh();
    } catch (e) {
      /* ignore */
    }
  }

  function escHtml(s) {
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;');
  }

  function selectOne(selector, root) {
    var scope = root || document;
    var el = scope.querySelector(selector);
    if (!el) throw new Error('Missing selector ' + selector);
    return el;
  }

  function pickProfilePhoto() {
    var gender = state.answers.gender;
    var age = state.answers.age;
    var male = maleProfileMap();
    var female = femaleProfileMap();
    var map = gender === 'Male' ? male : female;
    if (age && age.indexOf('Under') === 0) return map.teen;
    if (age && age.indexOf('20') === 0) return map.y20;
    if (age && age.indexOf('30') === 0) return map.y30;
    if (age && age.indexOf('40') === 0) return map.y40;
    return map.y50;
  }

  function maleProfileMap() {
    return {
      teen: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-teen_39fcf303-8cad-47d3-9c08-0727ad609e5b.jpg?v=1779277065',
      y20: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-20s_820f9187-a56f-4ce6-8c03-4d1dba396c67.jpg?v=1779277066',
      y30: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-30s_d51f796f-64d0-4ad7-b511-77da5e496b7e.jpg?v=1779277066',
      y40: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-40s_6cc22190-abad-4f8f-8fde-3ed89197b7e9.jpg?v=1779277066',
      y50: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/male-50s_105fa240-70c5-4e10-bbd1-8e50a8a5dba6.jpg?v=1779277066',
    };
  }

  function femaleProfileMap() {
    return {
      teen: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-teen_deef3960-bc98-4fe8-9a2e-b0a8327a2cc1.jpg?v=1779277065',
      y20: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-20s_ed41c8b1-e8f7-40df-8690-8398b0195f8c.jpg?v=1779277065',
      y30: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-30s_8eca2105-27fd-4a10-a6ed-aba0c30b0048.jpg?v=1779277064',
      y40: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-40s_82491222-921b-4de2-8033-b77a3f018ab4.jpg?v=1779277065',
      y50: ASSET_BASE + 'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/female-50s_301d8af3-d631-441e-8856-af15d1f54cae.jpg?v=1779277065',
    };
  }

  function replayScreenEnterAnimations(screenEl) {
    if (!screenEl) return;
    screenEl.querySelectorAll('.animate-fade-up').forEach(function (animated) {
      animated.classList.remove('animate-fade-up');
      void animated.offsetWidth;
      animated.classList.add('animate-fade-up');
    });
  }

  function navigateTo(screenId) {
    document.querySelectorAll('.screen').forEach(function (node) {
      var visible = node.getAttribute('data-screen') === screenId;
      node.classList.toggle('hidden', !visible);
      if (visible) replayScreenEnterAnimations(node);
    });
    window.scrollTo({ top: 0, behavior: 'smooth' });

    if (screenId === 'result') {
      var img = document.getElementById('result-profile-img');
      if (img) img.src = pickProfilePhoto();
    }
    if (screenId === 'milestone') launchConfetti();
    if (screenId === 'analyzing') startAnalyzingSequence();
    if (screenId === 'applying') startApplyingDiscount();
  }

  function launchConfetti() {
    function burst() {
      if (typeof confetti !== 'function') return;
      var colors = ['#22c55e', '#16a34a', '#86efac', '#fde68a', '#60a5fa'];
      setTimeout(function () {
        confetti({ particleCount: 90, spread: 75, startVelocity: 45, origin: { y: 0.4 }, colors: colors });
      }, 100);
      setTimeout(function () {
        confetti({ particleCount: 50, angle: 60, spread: 60, origin: { x: 0, y: 0.6 }, colors: colors });
        confetti({ particleCount: 50, angle: 120, spread: 60, origin: { x: 1, y: 0.6 }, colors: colors });
      }, 250);
      setTimeout(function () {
        confetti({ particleCount: 40, spread: 100, startVelocity: 30, origin: { y: 0.3 }, colors: colors, scalar: 0.9 });
      }, 700);
    }
    if (typeof confetti === 'function') burst();
    else window.addEventListener('load', burst);
  }

  /** classList.toggle() accepts one token only — not "a b c" strings. */
  function toggleClasses(el, classNames, on) {
    if (!el) return;
    String(classNames)
      .trim()
      .split(/\s+/)
      .filter(Boolean)
      .forEach(function (cls) {
        el.classList.toggle(cls, on);
      });
  }

  function syncQuizOpt(btn, on) {
    toggleClasses(btn, T.optBtnOn, on);
    if (btn.classList.contains('quiz-opt')) btn.setAttribute('aria-pressed', on ? 'true' : 'false');
  }

  function wireTeethGrid(container, progressHost, stepNum) {
    progressHost.className = T.progWrap;
    progressHost.innerHTML = progressInnerHtml(stepNum, TOTAL_QUESTIONS);
    container.className = 'grid grid-cols-2 gap-3';
    container.innerHTML = '';

    TEETH_CHOICES.forEach(function (tuple) {
      var valueKey = tuple[0];
      var src = tuple[1];
      var labelText = tuple[2];

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className =
        'quiz-teeth group flex flex-col overflow-hidden rounded-xl border-[1.5px] border-border bg-card text-left transition-all hover:border-primary';
      btn.innerHTML =
        '<div class="relative aspect-[4/3] overflow-hidden bg-muted">' +
        '<img class="size-full object-cover" loading="lazy" src="' +
        src +
        '" alt="' +
        escHtml(labelText) +
        '" />' +
        '<span class="absolute right-1.5 top-1.5 flex size-6 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground opacity-0 shadow-card transition-opacity group-[.is-selected]:opacity-100" aria-hidden="true">✓</span>' +
        '</div>' +
        '<div class="quiz-teeth-cap p-2.5 text-center transition-colors">' +
        '<div class="text-[13px] font-bold leading-tight text-foreground">' +
        escHtml(labelText) +
        '</div></div>';

      btn.addEventListener('click', function () {
        container.querySelectorAll('.quiz-teeth').forEach(function (b) {
          b.classList.remove('is-selected', 'border-primary', 'border-2', 'shadow-card');
          var cap = b.querySelector('.quiz-teeth-cap');
          if (cap) cap.classList.remove('bg-primary-soft');
        });
        btn.classList.add('is-selected', 'border-primary', 'border-2', 'shadow-card');
        var c = btn.querySelector('.quiz-teeth-cap');
        if (c) c.classList.add('bg-primary-soft');
        state.answers.teeth_state = valueKey;
        window.setTimeout(function () {
          navigateTo('q-concern');
        }, 280);
      });

      container.appendChild(btn);
    });
  }

  function wireSimpleQuestion(screenSelector, cfg) {
    var root = selectOne(screenSelector);
    root.innerHTML =
      '<div class="' +
      T.fade +
      '"><div class="' +
      T.progWrap +
      '">' +
      progressInnerHtml(cfg.stepNumber, TOTAL_QUESTIONS, cfg.labelOverride) +
      '</div><h2 class="' +
      T.qtext +
      '">' +
      cfg.title +
      '</h2><div data-role="list" class="' +
      T.optRowSimpleQ +
      '"></div></div>';

    var listEl = root.querySelector('[data-role="list"]');

    cfg.rows.forEach(function (row) {
      var iconTxt = row[0];
      var labelText = row[1];
      var iconHtml = iconTxt ? '<span class="' + T.optIcon + '">' + iconTxt + '</span>' : '';

      var b = document.createElement('button');
      b.type = 'button';
      b.className = T.optBtn;
      b.innerHTML = iconHtml + '<span>' + escHtml(labelText) + '</span>';

      b.addEventListener('click', function () {
        listEl.querySelectorAll('.quiz-opt').forEach(function (btn) {
          syncQuizOpt(btn, false);
        });
        syncQuizOpt(b, true);
        state.answers[cfg.answerField] = labelText;
        window.setTimeout(function () {
          navigateTo(cfg.nextScreen);
        }, 280);
      });

      listEl.appendChild(b);
    });
  }

  function wireCheckboxQuestion(screenSelector, cfg) {
    var root = selectOne(screenSelector);
    root.innerHTML =
      '<div data-quiz-stack class="' +
      T.fade +
      '"><div class="' +
      T.progWrap +
      ' prog-host"></div><h2 class="' +
      T.qtext +
      ' q-head"></h2><div data-role="checks" class="' +
      T.chkRow +
      '"></div><div data-role="next" class="quiz-next-host"></div></div>';

    var wrapEl = root.querySelector('[data-quiz-stack]');
    if (!wrapEl) throw new Error('Missing [data-quiz-stack] in ' + screenSelector);

    wrapEl.querySelector('.prog-host').innerHTML =
      progressInnerHtml(cfg.stepNumber, TOTAL_QUESTIONS, cfg.labelOverride);
    wrapEl.querySelector('.q-head').textContent = cfg.title;

    var checksHost = wrapEl.querySelector('[data-role="checks"]');
    var nextHost = wrapEl.querySelector('[data-role="next"]');

    nextHost.addEventListener('click', function (ev) {
      var t = ev.target.closest('[data-screen-continue]');
      if (!t || !nextHost.contains(t)) return;
      navigateTo(cfg.nextScreen);
    });

    function arr() {
      var stored = state.answers[cfg.answerField];
      return Array.isArray(stored) ? stored.slice() : [];
    }

    function syncChk(btn, on) {
      toggleClasses(btn, T.chkBtnOn, on);
      btn.classList.toggle('quiz-chk--on', on);
      var mark = btn.querySelector('.quiz-chk-marker');
      if (mark) {
        mark.textContent = on ? '✓' : '';
        toggleClasses(mark, T.chkMarkerOn, on);
        mark.classList.toggle('quiz-chk-marker--on', on);
      }
      var lab = btn.querySelector('.quiz-chk-label');
      if (lab) lab.classList.toggle('text-primary-deep', on);
    }

    function refreshAll() {
      var sel = arr();
      checksHost.querySelectorAll('.quiz-chk').forEach(function (btn) {
        var lix = Number(btn.getAttribute('data-line-index'));
        syncChk(btn, sel.indexOf(cfg.lines[lix]) !== -1);
      });
    }

    function refreshNext() {
      var s = arr();
      if (cfg.needsSelection && s.length === 0) {
        nextHost.innerHTML = '';
        return;
      }
      if (nextHost.querySelector('[data-screen-continue]')) return;
      nextHost.innerHTML =
        '<button type="button" class="' +
        T.nextBtn +
        '" data-screen-continue="" >' +
        escHtml(cfg.submitLabel) +
        '</button>';
      twRefreshSafe();
    }

    cfg.lines.forEach(function (lineLabel, ix) {
      var itemBtn = document.createElement('button');
      itemBtn.type = 'button';
      itemBtn.className = T.chkBtn + ' quiz-chk';
      itemBtn.setAttribute('data-line-index', String(ix));
      itemBtn.innerHTML =
        '<span class="quiz-chk-marker flex size-5 shrink-0 items-center justify-center rounded border-[1.5px] border-muted-foreground/40 text-xs" aria-hidden="true"></span><span class="' +
        T.chkLabel +
        ' quiz-chk-label"></span>';
      itemBtn.querySelector('.quiz-chk-label').textContent = lineLabel;
      itemBtn.addEventListener('click', function () {
        var w = arr();
        var ixv = w.indexOf(lineLabel);
        if (ixv === -1) w.push(lineLabel);
        else w.splice(ixv, 1);
        state.answers[cfg.answerField] = w;
        refreshAll();
        refreshNext();
      });
      checksHost.appendChild(itemBtn);
    });

    refreshAll();
    refreshNext();
  }

  function wireStainQuestion() {
    var selRoot = selectOne('[data-screen="q-stain"]');
    selRoot.innerHTML =
      '<div class="' +
      T.fade +
      '"><div class="' +
      T.progWrap +
      '">' +
      progressInnerHtml(9, TOTAL_QUESTIONS) +
      '</div><h2 class="' +
      T.qtext +
      '">What do you think is causing the staining?</h2>' +
      '<div class="' +
      T.stainGrid +
      '" data-role="stains"></div>' +
      '<button type="button" class="' +
      T.nextBtn +
      '" data-role="stain-done">Continue</button></div>';

    var stainHost = selRoot.querySelector('[data-role="stains"]');

    function paintStains() {
      var stored = Array.isArray(state.answers.stains) ? state.answers.stains : [];
      stainHost.querySelectorAll('.quiz-stain').forEach(function (btn) {
        var j = Number(btn.getAttribute('data-stain-ix'));
        var on = stored.indexOf(stainChoices[j][1]) !== -1;
        toggleClasses(btn, T.stainBtnOn, on);
        btn.classList.toggle('quiz-stain--on', on);
      });
    }

    stainChoices.forEach(function (tuple, ix) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = T.stainBtn + ' quiz-stain';
      b.setAttribute('data-stain-ix', String(ix));
      b.innerHTML =
        '<span class="' +
        T.stainIcon +
        '">' +
        tuple[0] +
        '</span><span class="' +
        T.stainLbl +
        '">' +
        escHtml(tuple[1]) +
        '</span>';

      b.addEventListener('click', function () {
        var stored = Array.isArray(state.answers.stains) ? state.answers.stains.slice() : [];
        var lbl = tuple[1];
        var at = stored.indexOf(lbl);
        if (at === -1) stored.push(lbl);
        else stored.splice(at, 1);
        state.answers.stains = stored;
        paintStains();
      });
      stainHost.appendChild(b);
    });

    var stainContinue = selRoot.querySelector('[data-role="stain-done"]');
    stainContinue.addEventListener('click', function () {
      navigateTo('edu-stains');
    });

    paintStains();
  }

  function mountMilestone() {
    selectOne('[data-screen="milestone"]').innerHTML =
      '<div class="animate-fade-up py-8 text-center">' +
      '<div class="relative mx-auto mb-6 size-32">' +
      '<span class="absolute inset-0 rounded-full bg-success/20 animate-ping-slow"></span>' +
      '<span class="absolute inset-2 rounded-full bg-success/15"></span>' +
      '<div class="relative flex size-full items-center justify-center rounded-full bg-success shadow-elevated animate-scale-in">' +
      '<svg class="size-14" viewBox="0 0 32 32" fill="none"><path d="M7 16l7 7L25 9" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div></div>' +
      '<h2 class="mb-3 px-2 text-[26px] font-extrabold uppercase leading-[1.15] tracking-tight text-foreground">You\'ve just taken your first step!</h2>' +
      '<p class="mx-auto mb-7 max-w-sm text-[14px] leading-relaxed text-muted-foreground">Congratulations on starting your path to <strong class="text-foreground">healthier teeth</strong> and a <strong class="text-foreground">brighter, more confident smile</strong>.</p>' +
      '<button type="button" class="' +
      T.bigCta +
      '" id="milestone-next">Continue</button></div>';

    selectOne('#milestone-next').addEventListener('click', function () {
      navigateTo('q-sensitivity');
    });
  }

  function mountEduStat() {
    selectOne('[data-screen="edu-stat"]').innerHTML =
      '<div class="' +
      T.fade +
      '"><div class="' +
      T.progWrap +
      '">' +
      progressInnerHtml(8, TOTAL_QUESTIONS) +
      '</div>' +
      '<div class="mb-4 rounded-2xl border border-border bg-card p-5 shadow-card animate-fade-up">' +
      '<div class="mb-2 text-[17px] font-bold leading-snug text-foreground">How Daily Drinks Can Affect Your Teeth </div>' +
      '<div class="space-y-2 text-[13.5px] leading-relaxed text-muted-foreground">' +
      '<p>Sipping sugary drinks throughout the day keeps the mouth in a constant acidic state. This limits saliva\'s ability to help replenish the minerals your teeth need to stay healthy. </p>' +
      '<figure class="my-3">' +
      '<img src="' +
      ASSET_BASE +
      'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/ph-acidity-chart_a7dffbee-a388-42c5-983a-bec5af963f89.jpg?v=1779276912" alt="Acidity (pH) chart of common drinks" loading="lazy" class="w-full rounded-xl border border-border"/>' +
      '<figcaption class="mt-2 text-center text-[11px] italic text-muted-foreground">Anything below pH 5.5 begins to challenge and demineralize enamel.</figcaption>' +
      '</figure></div></div>' +
      '<button type="button" class="' +
      T.bigCta +
      '" id="edu-stat-next">Continue</button></div>';

    selectOne('#edu-stat-next').addEventListener('click', function () {
      navigateTo('q-stain');
    });
  }

  function mountEduStains() {
    selectOne('[data-screen="edu-stains"]').innerHTML =
      '<div class="' +
      T.fade +
      '"><div class="' +
      T.progWrap +
      '">' +
      progressInnerHtml(10, TOTAL_QUESTIONS, '\u200b') +
      '</div>' +
      '<div class="mb-4 rounded-2xl border border-border bg-card p-5 shadow-card animate-fade-up">' +
      '<h3 class="mb-2 text-[17px] font-bold leading-snug text-foreground">' +
      '<mark class="rounded bg-primary-soft px-1 text-primary-deep">Stained or discolored teeth are one of the top reason</mark> adults feel self-conscious about their smile</h3>' +
      '<figure class="my-3"><img src="' +
      ASSET_BASE +
      'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/tooth-discoloration-types-v3_a1a2a614-2546-4989-b6c4-5dba28feb537.png?v=1779276913" alt="Types of stains" loading="lazy" class="w-full rounded-xl border border-border"/></figure>' +
      '<div class="space-y-2 text-[13.5px] leading-relaxed text-muted-foreground"><p>It\'s not just surface stains. <strong class="font-bold text-foreground underline">Acid buildup can also put stress on enamel and deplete the minerals that keep it protected.</strong> When that happens, the yellow layer underneath becomes more visible.</p></div></div>' +
      '<button type="button" class="' +
      T.bigCta +
      '" id="edu-stains-next">Continue</button></div>';

    selectOne('#edu-stains-next').addEventListener('click', function () {
      navigateTo('q-weartype');
    });
  }

  function mountConcern() {
    var rootSel = selectOne('[data-screen="q-concern"]');
    rootSel.innerHTML =
      '<div class="' +
      T.fade +
      '"><div class="' +
      T.progWrap +
      '">' +
      progressInnerHtml(2, TOTAL_QUESTIONS) +
      '</div>' +
      '<h2 class="' +
      T.qtext +
      '">What\'s <span class="text-primary">your biggest concern</span> about your teeth right now?</h2>' +
      '<div data-role="list" class="' +
      T.optRow +
      '"></div></div>';

    var listEl = rootSel.querySelector('[data-role="list"]');
    concernChoices.forEach(function (pair) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = T.optBtn;
      b.innerHTML = '<span class="' + T.optIcon + '">' + pair[0] + '</span><span>' + escHtml(pair[1]) + '</span>';
      b.addEventListener('click', function () {
        listEl.querySelectorAll('.quiz-opt').forEach(function (btn) {
          syncQuizOpt(btn, false);
        });
        syncQuizOpt(b, true);
        state.answers.concern = pair[1];
        window.setTimeout(function () {
          navigateTo('q-warnings');
        }, 280);
      });
      listEl.appendChild(b);
    });
  }

  function mountAge() {
    var panel = selectOne('[data-screen="q-age"]');
    var labels = ['50+ years old', '40 – 49 years old', '30 – 39 years old', '20 – 29 years old', 'Under 20'];

    panel.innerHTML =
      '<div class="' +
      T.fade +
      '">' +
      '<div class="' +
      T.progWrap +
      '" id="age-progress-slot"></div>' +
      '<h2 class="' +
      T.qtext +
      '">How old are you?</h2>' +
      '<div id="age-buttons-row" class="' +
      T.optRow +
      '"></div>' +
      '<div id="gender-shell" class="hidden"></div>' +
      '<div id="age-footer-slot"></div></div>';

    selectOne('#age-progress-slot').innerHTML = progressInnerHtml(14, TOTAL_QUESTIONS);

    var ageRow = selectOne('#age-buttons-row');
    var genderShell = selectOne('#gender-shell');
    var footerSlot = selectOne('#age-footer-slot');

    function revealGender() {
      if (!state.answers.age) return;
      if (genderShell.querySelector('[data-gender-choice]')) {
        genderShell.classList.remove('hidden');
        return;
      }
      genderShell.classList.remove('hidden');
      genderShell.innerHTML =
        '<div class="mt-6"><h2 class="' +
        T.qtextMuted +
        '">What\'s your gender?</h2>' +
        '<div class="mt-3 grid grid-cols-2 gap-2.5" id="gender-buttons-row"></div></div>';

      var gWrap = genderShell.querySelector('#gender-buttons-row');
      [['♀️', 'Female'], ['♂️', 'Male']].forEach(function (gp) {
        var g = document.createElement('button');
        g.type = 'button';
        g.className = T.optBtn;
        g.setAttribute('data-gender-choice', gp[1]);
        g.innerHTML =
          '<span class="' + T.optIcon + '">' + gp[0] + '</span><span>' + escHtml(gp[1]) + '</span>';
        g.addEventListener('click', function () {
          state.answers.gender = gp[1];
          redrawGenderBtns(gWrap);
          placeAgeContinue();
        });
        gWrap.appendChild(g);
      });
      redrawGenderBtns(gWrap);
      placeAgeContinue();
    }

    function redrawAgeBtns() {
      var sel = state.answers.age;
      ageRow.querySelectorAll('[data-age-label]').forEach(function (b) {
        syncQuizOpt(b, b.getAttribute('data-age-label') === sel);
      });
    }

    function redrawGenderBtns(gWrap) {
      var sel = state.answers.gender;
      if (!gWrap) return;
      gWrap.querySelectorAll('[data-gender-choice]').forEach(function (b) {
        syncQuizOpt(b, b.getAttribute('data-gender-choice') === sel);
      });
    }

    function placeAgeContinue() {
      if (!(state.answers.age && state.answers.gender)) return;
      if (footerSlot.querySelector('.quiz-next')) return;
      var c = document.createElement('button');
      c.type = 'button';
      c.className = T.nextBtn;
      c.textContent = 'Continue';
      c.addEventListener('click', function () {
        navigateTo('commit');
      });
      footerSlot.appendChild(c);
      twRefreshSafe();
    }

    labels.forEach(function (lbl) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = T.optBtn;
      b.setAttribute('data-age-label', lbl);
      b.innerHTML = '<span>' + escHtml(lbl) + '</span>';
      b.addEventListener('click', function () {
        state.answers.age = lbl;
        redrawAgeBtns();
        revealGender();
        redrawGenderBtns(panel.querySelector('#gender-buttons-row'));
        placeAgeContinue();
      });
      ageRow.appendChild(b);
    });

    redrawAgeBtns();
    if (state.answers.age) {
      revealGender();
      redrawGenderBtns(panel.querySelector('#gender-buttons-row'));
    }
    placeAgeContinue();
  }

  function mountCommit() {
    selectOne('[data-screen="commit"]').innerHTML =
      '<div class="animate-fade-up py-6 text-center">' +
      '<div class="mb-4 text-5xl">🦷</div>' +
      '<h2 class="mb-3 text-[22px] font-bold leading-[1.25] text-foreground">You\'re in the right place.</h2>' +
      '<p class="mx-auto mb-6 max-w-md text-sm leading-relaxed text-muted-foreground">Based on your answers, your enamel is showing multiple signs of active mineral loss. We\'re putting your results together now. </p>' +
      '<button type="button" class="' +
      T.bigCta +
      '" id="commit-go">See My Results</button></div>';

    selectOne('#commit-go').addEventListener('click', function () {
      navigateTo('analyzing');
    });
  }

  function resetAnalyzingTimers() {
    analyzingTimeouts.forEach(window.clearTimeout);
    analyzingTimeouts = [];
  }

  function startAnalyzingSequence() {
    resetAnalyzingTimers();
    var hostNode = selectOne('[data-screen="analyzing"]');
    var linesCopy = [
      'Reviewing your comfort and stain patterns…',
      'Assessing your mineral support needs…',
      'Mapping your remineralization needs…',
      'Identifying your key oral care habits…',
      'Building your personalized routine…',
    ];

    hostNode.innerHTML =
      '<div class="animate-fade-up py-10 text-center">' +
      '<h2 class="mb-7 text-xl font-bold text-foreground">Building your teeth care profile…</h2>' +
      '<div class="mx-auto mb-7 flex size-20 items-center justify-center rounded-full border-[3px] border-primary bg-primary-tint">' +
      '<svg class="size-10" viewBox="0 0 32 32" fill="none">' +
      '<path d="M7 16l7 7L25 9" stroke="hsl(178 65% 38%)" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
      '</div>' +
      '<div class="mx-auto flex max-w-xs flex-col gap-3 text-left" id="analyze-lines"></div></div>';

    var linesHost = selectOne('#analyze-lines', hostNode);
    linesCopy.forEach(function (line) {
      var row = document.createElement('div');
      row.className = 'analyze-line flex items-center gap-3 text-[13px] text-muted-foreground/60 transition-colors';
      row.innerHTML =
        '<span class="analyze-dot size-2.5 shrink-0 rounded-full bg-border"></span><span>' + escHtml(line) + '</span>';
      linesHost.appendChild(row);
    });

    function paintMarks(activeIx) {
      Array.prototype.forEach.call(linesHost.children, function (row, ri) {
        var dot = row.querySelector('.analyze-dot');
        row.classList.remove('text-foreground');
        row.classList.add('transition-colors');
        if (dot) {
          dot.classList.remove('bg-success', 'animate-pulse-soft', 'bg-primary', 'bg-border');
        }
        if (ri < activeIx) {
          row.classList.add('text-foreground');
          if (dot) dot.classList.add('bg-success');
        } else if (ri === activeIx) {
          row.classList.add('text-foreground');
          if (dot) dot.classList.add('bg-primary', 'animate-pulse-soft');
        } else if (dot) dot.classList.add('bg-border');
      });
    }

    var progIdx = { n: 0 };

    function tick() {
      if (selectOne('[data-screen="analyzing"]').classList.contains('hidden')) {
        resetAnalyzingTimers();
        return;
      }
      if (progIdx.n >= linesCopy.length) {
        analyzingTimeouts.push(
          window.setTimeout(function () {
            navigateTo('result');
          }, 600),
        );
        paintMarks(linesCopy.length);
        return;
      }
      paintMarks(progIdx.n);
      analyzingTimeouts.push(
        window.setTimeout(function () {
          progIdx.n++;
          tick();
        }, 800),
      );
    }
    tick();
  }

  function mountResultSummary() {
    selectOne('[data-screen="result"]').innerHTML =
      '<div class="' +
      T.fade +
      '">' +
      '<h1 class="mb-3 text-center text-[22px] font-bold leading-[1.25] text-foreground">Summary of your profile</h1>' +
      '<div class="relative mb-3 overflow-hidden rounded-2xl border border-border bg-card p-4 shadow-card">' +
      '<div class="mb-1 flex items-start justify-between">' +
      '<div class="text-[13px] font-bold text-foreground">Level of Enamel Risk</div>' +
      '<div class="rounded-md border-2 border-primary px-2 py-1 text-[10px] font-extrabold tracking-widest text-primary-deep">HIGH LEVEL</div></div>' +
      '<div class="relative -mx-1 mb-3 flex h-44 items-end justify-center overflow-hidden rounded-xl bg-white">' +
      '<img id="result-profile-img" class="h-full w-auto object-contain object-bottom" alt="Your profile" loading="lazy" width="768" src="' +
      pickProfilePhoto() +
      '"/></div>' +
      '<div class="relative px-1">' +
      '<div class="relative h-3 rounded-full" style="background:linear-gradient(to right, hsl(var(--success)), hsl(var(--warning)) 55%, hsl(var(--danger)))">' +
      '<div class="absolute -top-9 flex translate-x-[-50%] flex-col items-center" style="left:75%"></div>' +
      '<div class="absolute -top-1 size-5 translate-x-[-50%] rounded-full border-[3px] border-primary bg-card shadow-elevated" style="left:75%"></div></div>' +
      '<div class="mt-2 flex justify-between text-[9px] font-bold uppercase tracking-wider text-muted-foreground"><span>Low</span><span>Normal</span><span>Medium</span><span>High</span></div>' +
      '</div>' +
      '<div class="mt-4 flex gap-2.5 rounded-lg border border-primary/20 bg-primary-tint p-3">' +
      '<span class="text-base">⚠️</span><div><strong class="mb-0.5 block text-[12px] text-primary-deep">Enamel Assessment: DECLINING</strong>' +
      '<p class="m-0 text-[11px] leading-relaxed text-muted-foreground">Your enamel is significantly below peak. This results from accumulated acid exposure, mineral loss, and daily habits.</p></div></div>' +
      '<div class="mt-3 grid grid-cols-2 gap-2">' +
      [['⚡', 'Decline pattern', 'Progressive'], ['📈', 'Room for improvement', 'High'], ['🔥', 'Root causes', 'Diet + Routine'], ['🦷', 'Quality of life impact', 'Substantial']]
        .map(function (c) {
          return (
            '<div class="flex items-start gap-2 rounded-lg bg-muted/60 p-2.5">' +
            '<span class="text-sm">' +
            c[0] +
            '</span><div><div class="mb-0.5 text-[9px] font-bold uppercase tracking-wider text-muted-foreground">' +
            escHtml(c[1]) +
            '</div><div class="text-[12px] font-bold leading-tight text-foreground">' +
            escHtml(c[2]) +
            '</div></div></div>'
          );
        })
        .join('') +
      '</div></div>' +
      '<div class="mb-3 rounded-2xl border border-border bg-card p-5 shadow-card">' +
      '<div class="mb-3 text-sm font-bold text-foreground">Key findings from your answers</div>' +
      '<ul class="flex flex-col gap-2.5">' +
      [
        'Regular acid exposure may be wearing down enamel',
        'Regular acid exposure may be gradually wearing down your enamel minerals. ',
        'Staining pattern suggests both surface and structural discoloration',
        'Staining pattern suggests surface discoloration',
        'Oral microbiome may be disrupted, affecting breath and overall oral comfort.',
      ]
        .map(function (l) {
          return (
            '<li class="flex items-start gap-2.5 text-[13px] leading-relaxed text-muted-foreground"><span class="mt-2 size-1.5 shrink-0 rounded-full bg-primary"></span>' +
            escHtml(l) +
            '</li>'
          );
        })
        .join('') +
      '</ul></div>' +
      '<button type="button" class="' +
      T.bigCta +
      '" id="result-next">See my personalized solution</button></div>';

    selectOne('#result-next').addEventListener('click', function () {
      navigateTo('timeline');
    });
  }

  function mountTimeline() {
    var cards = [
      ['🌬️', 'Fresher breath'],
      ['🦷', 'Stronger-feeling teeth'],
      ['✨', 'Brighter natural shade'],
      ['🛡️', 'Daily enamel protection'],
      ['🍃', 'More comfortable gums'],
      ['😁', 'More smile confidence'],
    ];

    selectOne('[data-screen="timeline"]').innerHTML =
      '<div class="' +
      T.fade +
      '">' +
      '<h1 class="mb-4 text-center text-[22px] font-bold leading-[1.25] text-foreground">Your personalized solution</h1>' +
      '<p class="mb-4 text-center text-sm leading-relaxed text-muted-foreground">Based on your answers, here\'s what consistent daily use of LarineCo™ can support:</p>' +
      '<div class="mb-4 rounded-2xl border border-border bg-card p-4 shadow-card">' +
      '<div class="grid grid-cols-2 gap-2.5">' +
      cards
        .map(function (item, i) {
          return (
            '<div class="animate-fade-up rounded-xl border border-border bg-background/50 p-3 opacity-0" style="animation-delay:' +
            i * 80 +
            'ms;animation-fill-mode:forwards">' +
            '<div class="mb-1.5 text-2xl leading-none">' +
            item[0] +
            '</div><div class="text-[12.5px] font-bold leading-tight text-foreground">' +
            escHtml(item[1]) +
            '</div></div>'
          );
        })
        .join('') +
      '</div></div>' +
      '<div class="mb-4 rounded-2xl border border-primary/15 bg-primary-tint p-5">' +
      '<div class="flex items-start gap-4">' +
      '<img src="' +
      ASSET_BASE +
      'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/testimonial-mark.png?v=1779276913" alt="SARAH T." loading="lazy" class="size-20 shrink-0 rounded-full border-2 border-card object-cover object-top shadow-card"/><div>' +
      '<p class="mb-2 text-[13.5px] italic leading-relaxed text-muted-foreground">"That zing with cold water was basically gone. I used to sip everything through a straw or eat on the side of my mouth. I hadn\'t realized how much I\'d been avoiding until I stopped having to."</p>' +
      '<div class="flex items-center gap-2">' +
      '<span class="text-[11px] font-bold tracking-wide text-foreground">SARAH T.</span><span class="text-[10px] text-success">★★★★★</span></div>' +
      '<div class="mt-0.5 text-[10px] uppercase tracking-wider text-primary">Verified Customer</div></div></div></div>' +
      '<button type="button" class="' +
      T.bigCta +
      ' mt-4" id="timeline-next">See how it works</button></div>';

    selectOne('#timeline-next').addEventListener('click', function () {
      navigateTo('applying');
    });
  }

  function clearApplyingTimeouts() {
    applyingTimeouts.forEach(window.clearTimeout);
    applyingTimeouts = [];
  }

  function startApplyingDiscount() {
    clearApplyingTimeouts();
    selectOne('[data-screen="applying"]').innerHTML =
      '<div class="animate-fade-up flex flex-col items-center py-16 text-center">' +
      '<div class="relative mb-10 size-44">' +
      '<span class="absolute inset-0 rounded-full border border-primary/30 animate-ping-slow"></span>' +
      '<span class="absolute inset-2 rounded-full border border-primary/20 animate-ping-slower"></span>' +
      '<svg id="ap-spin" class="absolute inset-0 size-full animate-spin-slow" viewBox="0 0 120 120"><defs><linearGradient id="larine-ring-grad"><stop offset="0%" stop-color="hsl(178 65% 38%)" stop-opacity="0"/><stop offset="100%" stop-color="hsl(178 65% 38%)"/></linearGradient></defs>' +
      '<circle cx="60" cy="60" r="54" fill="none" stroke="hsl(var(--border))" stroke-width="2"/>' +
      '<circle cx="60" cy="60" r="54" fill="none" stroke="url(#larine-ring-grad)" stroke-linecap="round" stroke-dasharray="200 340" stroke-width="3"/></svg>' +
      '<svg id="ap-check-svg" class="absolute inset-0 size-full scale-90 opacity-0 transition-all duration-500" viewBox="0 0 120 120">' +
      '<circle cx="60" cy="60" r="54" fill="none" stroke="hsl(var(--primary))" stroke-width="3"/>' +
      '<path id="ap-path" stroke="hsl(var(--primary))" stroke-dasharray="80" stroke-dashoffset="80" stroke-linecap="round" stroke-linejoin="round" stroke-width="4.5" fill="none" d="M40 62 L54 76 L82 46"/></svg></div>' +
      '<div class="mb-3 text-[11px] font-bold uppercase tracking-[0.3em] text-primary" id="ap-label">Almost there</div>' +
      '<h2 id="ap-head" class="mb-2 text-2xl font-bold text-foreground">Applying your discount…</h2>' +
      '<p id="ap-sub" class="mx-auto max-w-xs text-sm text-muted-foreground">Hold tight — we\'re personalizing your offer based on your enamel profile.</p>' +
      '<div class="mt-8 flex items-center gap-2" id="ap-dots">' +
      '<span class="dot size-1.5 rounded-full bg-primary transition-colors"></span>' +
      '<span class="dot size-1.5 rounded-full bg-border transition-colors"></span>' +
      '<span class="dot size-1.5 rounded-full bg-border transition-colors"></span></div></div>';

    applyingTimeouts.push(
      window.setTimeout(function () {
        selectOne('#ap-spin').classList.add('opacity-0');
        var chk = selectOne('#ap-check-svg');
        chk.classList.remove('scale-90', 'opacity-0');
        chk.classList.add('scale-100', 'opacity-100');
        var pathLine = selectOne('#ap-path');
        pathLine.style.transition = 'stroke-dashoffset 0.6s ease-out 0.1s';
        pathLine.setAttribute('stroke-dashoffset', '0');
      }, 1600),
    );

    applyingTimeouts.push(
      window.setTimeout(function () {
        selectOne('#ap-dots').children[1].classList.remove('bg-border');
        selectOne('#ap-dots').children[1].classList.add('bg-primary');
      }, 2400),
    );

    applyingTimeouts.push(
      window.setTimeout(function () {
        var dots = selectOne('#ap-dots').children;
        dots[2].classList.remove('bg-border');
        dots[2].classList.add('bg-primary');
        selectOne('#ap-label').textContent = 'Success';
        selectOne('#ap-head').textContent = 'Discount applied!';
        selectOne('#ap-sub').textContent = 'Redirecting you to your personalized plan…';
        navigateTo('product');
      }, 3400),
    );
  }

  function mountProduct() {
    selectOne('[data-screen="product"]').innerHTML =
      '<div class="' +
      T.fade +
      '">' +
      '<h1 class="mb-4 text-center text-[22px] font-bold leading-[1.25] text-foreground">Your personalized solution is ready</h1>' +
      '<p class="mb-4 text-center text-sm leading-relaxed text-muted-foreground">Because you qualify, we recommend starting with a 3-month supply for best results. First-time customers get 50% off, backed by our 30-day money-back guarantee.</p>' +
      '<figure class="mb-4 overflow-hidden rounded-2xl border border-border shadow-elevated">' +
      '<img class="block w-full" loading="lazy" src="' +
      ASSET_BASE +
      'https://cdn.shopify.com/s/files/1/0904/3869/7251/files/larineco-hero_637e57a7-8562-4209-bcbe-46796eff983d.png?v=1779276913" alt="LarineCo"/></figure>' +
      '<div class="mb-3 rounded-2xl border border-border bg-card p-5 shadow-card">' +
      '<div class="mb-1 text-center text-[18px] font-bold text-foreground">LarineCo™ Remineralizing Gum</div>' +
      '<div class="mb-4 text-center text-[12px] leading-relaxed text-muted-foreground">Nano-Hydroxyapatite · Xylitol · Mastic · Myrrh · Spruce · Acacia</div>' +
      '<ul class="flex flex-col gap-2.5 text-left">' +
      [['🦷', 'Supports strong teeth and enamel at the mineral level'], ['✨', 'Brightens your smile naturally'], ['🌬️', 'Long-lasting fresh breath all day'], ['🛡️', 'Helps disrupt the environment odor-causing bacteria need to thrive'], ['💚', 'Supports healthy gums & a balanced oral microbiome'], ['⏱️', 'Works between brushes and meals']]
        .map(function (p) {
          return (
            '<li class="flex items-start gap-2.5 text-[13px] leading-relaxed text-foreground"><span class="w-5 shrink-0 text-center text-base">' +
            p[0] +
            '</span>' +
            escHtml(p[1]) +
            '</li>'
          );
        })
        .join('') +
      '</ul></div>' +
      '<div class="rounded-2xl border border-border bg-card p-5 text-center shadow-elevated">' +
      '<div class="mb-3 inline-flex items-center gap-2 rounded-full border border-primary/20 bg-primary-soft px-4 py-1.5">' +
      '<span class="text-[11px] font-bold uppercase tracking-widest text-primary-deep">Your Discount</span>' +
      '<span class="rounded-full bg-primary px-2.5 py-0.5 text-[12px] font-bold text-primary-foreground">50% OFF</span></div>' +
      '<a href="https://buylarine.com/products/larineco%E2%84%A2%EF%B8%8F-remineralizing-gum-copy"  class="' +
      T.bigCta +
      '">Claim My 50% Off</a>' +
      '<div class="mt-3 text-[11px] text-muted-foreground">Try risk-free for 30 days</div></div></div>';
  }

  function boot() {
    wireTeethGrid(selectOne('#teeth-intro-grid'), selectOne('#progress-intro'), 1);
    mountConcern();
    wireCheckboxQuestion('[data-screen="q-warnings"]', {
      stepNumber: 3,
      title: 'Which of these have you noticed?',
      lines: warningChoices,
      answerField: 'warnings',
      nextScreen: 'q-hopes',
      needsSelection: false,
      submitLabel: 'Continue',
    });
    wireCheckboxQuestion('[data-screen="q-hopes"]', {
      stepNumber: 4,
      title: 'What results are you hoping for from an oral care product?',
      lines: hopeChoices,
      answerField: 'hopes',
      nextScreen: 'milestone',
      needsSelection: true,
      submitLabel: 'Continue',
    });
    mountMilestone();
    wireSimpleQuestion('[data-screen="q-sensitivity"]', {
      stepNumber: 5,
      title: 'How sensitive are your teeth to hot, cold, or sweet things?',
      rows: [
        ['🔥', 'Constant — even normal food and drinks hurt'],
        ['❄️', 'Noticeable with hot, cold, or sweet things'],
        ['😐', 'Mild — comes and goes'],
        ['✅', 'Not sensitive — just want to protect my teeth'],
      ],
      answerField: 'sensitivity',
      nextScreen: 'q-acidic',
    });
    wireSimpleQuestion('[data-screen="q-acidic"]', {
      stepNumber: 7,
      title: 'How often do you drink coffee, tea, soda, or citrus drinks?',
      rows: [
        ['☕', 'Multiple times a day'],
        ['🥤', 'Once a day'],
        ['📅', 'A few times a week'],
        ['💧', 'Rarely or never'],
      ],
      answerField: 'acidic',
      nextScreen: 'edu-stat',
    });
    mountEduStat();
    wireStainQuestion();
    mountEduStains();
    wireCheckboxQuestion('[data-screen="q-weartype"]', {
      stepNumber: 11,
      title: 'Which oral care products are currently part of your routine?',
      lines: routineChoices,
      answerField: 'routine',
      nextScreen: 'q-brush',
      needsSelection: false,
      submitLabel: 'Continue',
    });
    wireSimpleQuestion('[data-screen="q-brush"]', {
      stepNumber: 12,
      title: 'How often do you brush your teeth?',
      rows: [
        ['', '3+ times a day'],
        ['', 'Twice a day'],
        ['', 'Once a day'],
        ['', 'Inconsistently'],
      ],
      answerField: 'brush',
      nextScreen: 'q-dentist',
    });
    wireSimpleQuestion('[data-screen="q-dentist"]', {
      stepNumber: 13,
      title: 'How often do you visit the dentist?',
      rows: [
        ['📆', 'Every 6 months — I\'m consistent'],
        ['🗓️', 'Once a year'],
        ['⏳', 'Every couple of years'],
        ['😬', 'I avoid the dentist'],
      ],
      answerField: 'dentist',
      nextScreen: 'q-age',
    });
    mountAge();
    mountCommit();
    mountResultSummary();
    mountTimeline();
    mountProduct();
    navigateTo('intro');
    twRefreshSafe();
  }

  document.addEventListener('DOMContentLoaded', boot);
})();
